import { FileUp } from 'lucide-react';
import React from 'react';
import { EmptyState } from '../components';

export const ResumesTab = () => {
  return (
    <EmptyState
      icon={FileUp}
      title="No Resume Uploaded"
      subtitle="Upload your resume to get started with applications."
    />
  );
};
